var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92412 21.6778H20.0761C22.1551 21.6778 23.1897 20.6732 23.1897 18.6143V8.84078C23.1897 6.79178 22.1551 5.77692 20.0761 5.77692H17.9465V5.14435C17.9465 3.18578 16.9724 2.32178 15.1137 2.32178H8.88655C7.12855 2.32178 6.04383 3.18578 6.04383 5.14435V5.77692H3.92412C1.84512 5.77692 0.810547 6.79178 0.810547 8.84078V18.6143C0.810547 20.6732 1.84512 21.6778 3.92412 21.6778ZM7.6004 5.03378C7.6004 4.20021 8.0324 3.77806 8.86598 3.77806H15.1343C15.9678 3.77806 16.39 4.20021 16.39 5.03378V5.77692H7.59998L7.6004 5.03378ZM2.42755 8.92092C2.42755 7.89663 2.94998 7.38449 3.94469 7.38449H20.056C21.0404 7.38449 21.5727 7.89663 21.5727 8.92092V11.5729H2.42755V8.92092ZM3.94469 20.0706C2.94998 20.0706 2.42755 19.5683 2.42755 18.5338V13.0798H8.0324V13.7029C8.0324 14.5266 8.50469 14.9985 9.33826 14.9985H14.662C15.4857 14.9985 15.9678 14.5262 15.9678 13.7029V13.0798H21.5727V18.5338C21.5727 19.5683 21.0404 20.0706 20.056 20.0706H3.94469Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.9fef84bd3e75b84c6203ea29e5317496.svg";
export { ForwardRef as ReactComponent };